import {
  faCaretDown,
  faCaretUp,
  faChevronCircleDown,
  faChevronCircleUp,
  faLock,
  faLockOpen,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeFormulaTypeFromDays,
  changeFormulaTypeFromGranularToRaw,
  formulaTotalChange,
  lockFormulaByFormulaId,
  removeFormulaFromSection,
} from "../../actions/formulaAction";
import AddHerbPopup from "../../pages/CustomFormulaBuilder/AddHerbPopup";
import HerbItem from "../HerbItem";
import { getUserDetail } from "../../utils/helper";
const FormulaList = ({
  showUnavailableHerbs,
  rawGramPerDayBeforeConversion,
  formula,
  isRawType,
  isOuterLocked,
}) => {
  const [showAddHerb, setShowAddHerb] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const role = useSelector((state) => state.role.role);
  const [isTotalChanged, setIsTotalChanged] = useState(false);
  const [totalDosage, setTotalDosage] = useState(formula.formulaDosage);
  const [canEditPercentage, setCanEditPercentage] = useState(false);
  const dispatch = useDispatch();
  const isAllowed = getUserDetail()?.practitioner_status == 1;
  useEffect(() => {
    if (isOuterLocked) {
      dispatch(lockFormulaByFormulaId(formula.formulaId, false));
    }
  }, [isOuterLocked, dispatch]);

  useEffect(() => {
    setIsTotalChanged(true);
    setTotalDosage(formula.formulaDosage);
  }, [formula.formulaDosage]);

  useEffect(() => {
    let herbGreaterThanZero = formula?.formulaHerbs.filter((x) => x.dosage > 0);

    setCanEditPercentage(herbGreaterThanZero.length >= 2);
  }, formula?.formulaHerbs);

  return (
    <div className="item-wrapper">
      <div
        className={`delete-formula  `}
        style={{
          cursor: isRawType
            ? "pointer"
            : rawGramPerDayBeforeConversion != null && !isRawType
            ? "initial"
            : "pointer",
          opacity: isRawType
            ? 1
            : rawGramPerDayBeforeConversion != null && !isRawType
            ? 0
            : 1,
        }}
      >
        <FontAwesomeIcon
          icon={faTimesCircle}
          onClick={() => {
            if (
              isRawType ||
              (!isRawType && rawGramPerDayBeforeConversion == null)
            ) {
              if (!isRawType) {
                dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
                dispatch(removeFormulaFromSection(formula.formulaId));
                dispatch(changeFormulaTypeFromDays(false, 1));
              } else {
                dispatch(removeFormulaFromSection(formula.formulaId));
              }
            }
          }}
        />
      </div>
      <div
        className={`single-herb-section mt-2 ${
          formula.isLocked ? "locked" : ""
        }`}
      >
        {showAddHerb && (
          <AddHerbPopup
            showUnavailableHerbs={showUnavailableHerbs}
            showPopup={showAddHerb}
            closePopup={() => setShowAddHerb(false)}
            formulaId={formula.formulaId}
            role={role}
          />
        )}
        <div className="row">
          <div className="col-md-12 heading-section">
            <FontAwesomeIcon
              icon={isExpanded ? faChevronCircleUp : faChevronCircleDown}
              onClick={() => setIsExpanded(!isExpanded)}
            />
            <p className="formula-name">{formula.formulaName}</p>
          </div>
        </div>
        <div className={`${isExpanded ? "expanded" : "collapsed"}`}>
          <table className="table">
            <thead>
              <tr className="head">
                <th></th>
                <th className="formula-title">FORMULA HERBS</th>
                <th className="text-right pr-5">DOSAGE (G)</th>
                <th className="text-right">DOSAGE (%)</th>
                {!isRawType && <th className="text-right">HERB RATIO</th>}
                {!isRawType && isAllowed && (
                  <th className="text-right">PRICE</th>
                )}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {formula.formulaHerbs
                .filter((x) => !x.isAdditional && !x.isModification)
                .map((herb) => (
                  <HerbItem
                    canEditPercentage={canEditPercentage}
                    rawGramPerDayBeforeConversion={
                      rawGramPerDayBeforeConversion
                    }
                    isRawType={isRawType}
                    herb={herb}
                    key={herb.id}
                    totalDosage={formula.formulaDosage}
                    formulaId={formula.formulaId}
                    isLocked={formula.isLocked || isOuterLocked}
                    isOuterLocked={isOuterLocked}
                  />
                ))}
              <tr>
                <td></td>
                <td className="sub-heading-text "> SUGGESTED MODIFICATIONS</td>
                <td></td>
                <td></td>
                {!isRawType && <td></td>}
                {!isRawType && isAllowed && <td></td>}
                <td></td>
              </tr>
              {formula.modificationName && (
                <tr>
                  <td></td>
                  <td className="sub-heading-text modification">
                    {formula.modificationName}
                  </td>
                  <td></td>
                  <td></td>
                  {!isRawType && <td></td>}
                  {!isRawType && isAllowed && <td></td>}
                  <td></td>
                </tr>
              )}
              {formula.formulaHerbs
                .filter((x) => x.isModification)
                .map((herb) => (
                  <HerbItem
                    canEditPercentage={canEditPercentage}
                    rawGramPerDayBeforeConversion={
                      rawGramPerDayBeforeConversion
                    }
                    isRawType={isRawType}
                    herb={herb}
                    key={herb.id}
                    isLocked={formula.isLocked || isOuterLocked}
                    totalDosage={formula.formulaDosage}
                    formulaId={formula.formulaId}
                    isOuterLocked={isOuterLocked}
                  />
                ))}
              <tr>
                <td></td>
                <td className="sub-heading-text"> ADDITIONAL HERB(S) </td>
                <td></td>
                <td></td>
                {!isRawType && <td></td>}
                {!isRawType && isAllowed && <td></td>}
                <td></td>
              </tr>
              {formula.formulaHerbs
                .filter((x) => x.isAdditional)
                .map((herb) => (
                  <HerbItem
                    canEditPercentage={canEditPercentage}
                    rawGramPerDayBeforeConversion={
                      rawGramPerDayBeforeConversion
                    }
                    isRawType={isRawType}
                    herb={herb}
                    key={herb.id}
                    totalDosage={formula.formulaDosage}
                    isLocked={formula.isLocked || isOuterLocked}
                    isOuterLocked={isOuterLocked}
                    formulaId={formula.formulaId}
                  />
                ))}
              {!(rawGramPerDayBeforeConversion != null && !isRawType) ? (
                <tr>
                  <td></td>
                  <td>
                    <button
                      disabled={
                        rawGramPerDayBeforeConversion != null && !isRawType
                      }
                      type="button"
                      className="btn-orange"
                      onClick={() => setShowAddHerb(true)}
                    >
                      Add Herb
                    </button>
                  </td>
                  <td></td>
                  <td></td>
                  {!isRawType && <td></td>}
                  {!isRawType && isAllowed && <td></td>}
                  <td></td>
                </tr>
              ) : null}
              <tr className="total-section">
                <td></td>
                <td>TOTAL GRAMS FOR THIS FORMULA:</td>
                <td className={`text-right pr-5`}>
                  {true ? (
                    `${formula.formulaDosage.toLocaleString("en-US", {
                      maximumFractionDigits: 1,
                      minimumFractionDigits: 1,
                    })} grams`
                  ) : (
                    <div
                      className={`d-flex align-items-center justify-content-end mr-1 ${
                        isOuterLocked && "outer-locked"
                      }`}
                    >
                      <button
                        className={`lock-btn ${formula.isLocked && "locked"} ${
                          isOuterLocked && "outer-locked"
                        }`}
                        type="button"
                        onClick={() => {
                          dispatch(
                            lockFormulaByFormulaId(
                              formula.formulaId,
                              !formula.isLocked
                            )
                          );
                        }}
                      >
                        <FontAwesomeIcon
                          icon={formula.isLocked ? faLock : faLockOpen}
                        />
                      </button>
                      <div
                        className={` number-field mr-2  ${
                          formula.isLocked && "outer-locked"
                        }`}
                      >
                        <input
                          type="number"
                          min="0"
                          step="any"
                          value={totalDosage}
                          onChange={(e) => setTotalDosage(e.target.value)}
                          onBlur={(e) =>
                            dispatch(
                              formulaTotalChange(
                                formula.formulaId,
                                parseFloat(e.target.value)
                              )
                            )
                          }
                        />
                        <div>
                          <div
                            className="icon"
                            onClick={() => {
                              dispatch(
                                formulaTotalChange(
                                  formula.formulaId,
                                  formula.formulaDosage +
                                    (isTotalChanged ? 0.5 : 1)
                                )
                              );
                              setIsTotalChanged(false);
                            }}
                          >
                            <FontAwesomeIcon icon={faCaretUp} />
                          </div>
                          <div
                            className="icon"
                            onClick={() =>
                              parseFloat(formula.formulaDosage) > 0
                                ? dispatch(
                                    formulaTotalChange(
                                      formula.formulaId,
                                      formula.formulaDosage -
                                        (isTotalChanged ? 0.5 : 1)
                                    )
                                  )
                                : dispatch(
                                    formulaTotalChange(formula.formulaId, 0)
                                  )
                            }
                          >
                            <FontAwesomeIcon icon={faCaretDown} />
                          </div>
                        </div>
                      </div>
                      grams
                    </div>
                  )}
                </td>
                <td></td>
                {!isRawType && <td></td>}
                {!isRawType && isAllowed && (
                  <td className="text-right">
                    {formula.formulaPrice.toLocaleString("en-US", {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
                  </td>
                )}
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FormulaList;
